// @flow

type Params = {
  catalogID: string,
  catalogTwoEs?: string,
  catalogTwoCa?: string,
  catalogFourEs?: string,
  catalogFourCa?: string,
  allTwoEs?: string,
  allTwoCa?: string,
  allFourEs?: string,
  allFourCa?: string
}

export const creativityMediaModel = (params: Params) => ({
  [params.catalogID]: {
    '2': {
      es: params.catalogTwoEs,
      ca: params.catalogTwoCa
    },
    '4': {
      es: params.catalogFourEs,
      ca: params.catalogFourCa
    }
  },
  all: {
    '2': {
      es: params.allTwoEs,
      ca: params.allTwoCa
    },
    '4': {
      es: params.allFourEs,
      ca: params.allFourCa
    }
  }
})
